var Alberta = "ألبرتا";
var Manitoba = "مانيتوبا";
var Nunavut = "نونافوت";
var Ontario = "أونتاريو";
var Quebec = "كيبيك";
var Saskatchewan = "ساسكاتشوان";
var Yukon = "يوكون";
var CAStates = {
	Alberta: Alberta,
	"British Columbia": "كولومبيا البريطانية",
	Manitoba: Manitoba,
	"New Brunswick": "نيوبرونزويك",
	"Newfoundland and Labrador": "نيوفاوندلاند ولابرادور",
	"Northwest Territories": "الأقاليم الشمالية الغربية",
	"Nova Scotia": "نوفا سكوتيا",
	Nunavut: Nunavut,
	Ontario: Ontario,
	"Prince Edward Island": "جزيرة الأمير إدوارد",
	Quebec: Quebec,
	Saskatchewan: Saskatchewan,
	Yukon: Yukon
};

export { Alberta, Manitoba, Nunavut, Ontario, Quebec, Saskatchewan, Yukon, CAStates as default };
